import { UserStatsDto } from 'booksprout'
import { UINotification, UIState } from './types'
import { defineState } from '../../../base/store/defineState'

export const resetNotificationState = (): UINotification[] => {
  return []
}

/**
 * Every key is declared up front: Vue 2.7's `reactive()` is `Vue.observable`, so a key added after
 * creation is not reactive.
 */
export const defaultState = (): UIState => ({
  notifications: resetNotificationState(),
  unreadMessageCount: 0,
  unreadNotificationCount: {
    author: 0,
    reviewer: 0
  },
  redirect: void 0,
  triggerLoginNotification: false,
  loginForwardUrl: '',
  showMessageDialog: {
    show: false,
    error: false,
    message: '',
    optionalParams: []
  },
  userStats: new UserStatsDto(),
  isReadyToRender: false,
  lastError: ''
})

export const resetUiState = () => {
  return defaultState()
}

export default defineState<UIState>('ui', defaultState)
